import { Tab, Tabs } from '@trackman/web-shared-components';
import { useStores } from 'index';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabWrapper } from './SessionTabsStyles';
import { LiveDashboardView } from 'pages/Metrics/Metrics';

export const SessionTabs = observer(() => {
  const uiStore = useStores().uiStore;
  const gameStore = useStores().gameStore;

  return (
    <TabWrapper>
      <Tabs onChange={(_, newValue) => uiStore.setCurrentView(newValue)} value={uiStore.currentView}>
        <Tab label='Dashboard' data-testid='tab-dashboard' value={LiveDashboardView.Dashboard} />
        {!gameStore.hidePitchLocation && <Tab label='Strike zone' data-testid='tab-strikezone' value={LiveDashboardView.Strikezone} />}
        <Tab label='List' data-testid='tab-gamelist' value={LiveDashboardView.List} />
      </Tabs>
    </TabWrapper>
  );
});
